module.exports = __webpack_public_path__ + "static/media/five-pcs-box__square.9f1f879c.png";